import {FATAL_ERROR} from './actions/fatalError'
import {ERROR, CLEAR_ERROR} from './actions/error'
import {CLOSE_SEARCH_BOX, OPEN_SEARCH_BOX} from './actions/searchBox'

import {ModuleActionType} from './actions'
import {CommonErrorPayloadFormatType} from 'types/errorResponse'

import {
  offerCheckDone,
  offerCheckError,
  offerCheckFatalError
} from 'modules/offerCheck/slice'

export type CommonStateType = {
  error: CommonErrorPayloadFormatType | null | undefined
  isSearchBoxVisible: boolean
  moduleState: string
}

const initialState = {
  error: null,
  isSearchBoxVisible: false
}

const reducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: CommonStateType = initialState,
  action: ModuleActionType
) => {
  switch (action.type) {
    case FATAL_ERROR:
    case ERROR: {
      return {
        ...state,
        error: action.error,
        moduleState: action.type
      }
    }

    case CLEAR_ERROR: {
      return {
        ...state,
        error: null,
        moduleState: action.type
      }
    }

    case OPEN_SEARCH_BOX: {
      return {
        ...state,
        isSearchBoxVisible: true,
        moduleState: action.type
      }
    }

    case CLOSE_SEARCH_BOX: {
      return {
        ...state,
        isSearchBoxVisible: false,
        moduleState: action.type
      }
    }

    case offerCheckDone.type: {
      return {
        ...state,
        httpRequestId: (action as typeof offerCheckDone)?.meta?.headers[
          'x-request-id'
        ]
      }
    }

    case offerCheckError.type:
    case offerCheckFatalError.type: {
      return {
        ...state,
        httpRequestId: action?.meta?.headers?.['x-request-id']
      }
    }

    default: {
      return state
    }
  }
}

export default reducer
